export const ANONYMOUS_PERMISSION_SEARCH_RESULTS = 'search_results';

export function isAnonymousFlowEnabled(profile, permission) {
    if (profile?.elal_smsession_present) return false;

    return Boolean(
        permission &&
            profile?.company?.settings?.allow_anonymous_users &&
            profile?.company?.settings?.anonymous_user_permissions?.[permission],
    );
}
